import { render, staticRenderFns } from "./ColorsColumnTemplateComponent.vue?vue&type=template&id=1c057a8f&scoped=true&lang=pug"
import script from "./ColorsColumnTemplateComponent.vue?vue&type=script&lang=ts"
export * from "./ColorsColumnTemplateComponent.vue?vue&type=script&lang=ts"
import style0 from "./ColorsColumnTemplateComponent.vue?vue&type=style&index=0&id=1c057a8f&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c057a8f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1c057a8f')) {
      api.createRecord('1c057a8f', component.options)
    } else {
      api.reload('1c057a8f', component.options)
    }
    module.hot.accept("./ColorsColumnTemplateComponent.vue?vue&type=template&id=1c057a8f&scoped=true&lang=pug", function () {
      api.rerender('1c057a8f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/grids/ColumnTemplates/ColorsColumnTemplateComponent.vue"
export default component.exports